import Swiper from "swiper";

export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    loop: false,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
    
    navigation: {
      nextEl: '.swiper-button-next.banners',
      prevEl: '.swiper-button-prev.banners',
    },
  });

  const swiperNewModels = new Swiper('.swiper-new-model', {
    observer: true,
    observeParents: true,
    watchOverflow: true,
    slidesPerView: 1,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next-new-model',
      prevEl: '.swiper-button-prev-new-model',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
    pagination: {
      el: '.swiper-pagination.new-model',
      dynamicBullets: true,
      clickable: true,
    }
  });

  const swiperPromotion = new Swiper('.swiper-promotion', {
    slidesPerView: 1,
    spaceBetween: 15,
    watchOverflow: true,
    observer: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.promotion',
      prevEl: '.swiper-button-prev.promotion',
    },
    pagination: {
      el: '.swiper-pagination.promotion',
      clickable: true,
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1600: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      
    },
  });


  const swiperProductsHighlights = new Swiper('.swiper-products-highlights', {
    slidesPerView: 1,
    spaceBetween: 30,
    watchOverflow: true,
    observer: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.products-highlights',
      prevEl: '.swiper-button-prev.products-highlights',
    },
    pagination: {
      el: '.swiper-pagination.products-highlights',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  const swiperServices = new Swiper ('.swiper-services', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    spaceBetween: 15,
    navigation: {
      nextEl: '.swiper-button-next.services',
      prevEl: '.swiper-button-prev.services',
    },
    pagination: {
      el: '.swiper-pagination.services',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    }
  });

  
  const swiperGalleryInstitucional = new Swiper ('.swiper-gallery-institutional', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    centerInsufficientSlides: true,
    watchOverflow: true,
    slidesPerView: 2,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next.gallery-institutional',
      prevEl: '.swiper-button-prev.gallery-institutional',
    },
    pagination: {
      el: '.swiper-pagination.gallery-institutional',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    }
  });

  const swiperCategories = new Swiper('.swiper-categories', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    centerInsufficientSlides: true,
    watchOverflow: true,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next.categories',
      prevEl: '.swiper-button-prev.categories',
    },
    breakpoints: {
      992: {
        slidesPerView: 8,
        spaceBetween: 5,
      },
    },
  });

  const swiperUsedModelInternalStamp = new Swiper('.used-model-internal-stamps-slider', {
    clickable: true,
    slidesPerView: 3,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination.stamp',
      clickable: true
    },
  });

  const swiperUsedModelInternalThumbs = new Swiper('.used-model-internal-slider-thumbs', {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 60,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.used-thumbs',
      prevEl: '.swiper-button-prev.used-thumbs',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const usedModelInternalSwiper = new Swiper('.used-model-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.used',
      prevEl: '.swiper-button-prev.used',
    },
    clickable: true,
    thumbs: {
      swiper: swiperUsedModelInternalThumbs,
    },
  });

  const swiperBlogInternalRelated = new Swiper('.blog-internal-related-slider', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    slidesPerView: 1,
    watchOverflow: true,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.blog-internal',
      prevEl: '.swiper-button-prev.blog-internal',
    },
    pagination: {
      el: '.swiper-pagination.blog-internal',
      clickable: true
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    }
  });

  const swiperUsedModelInternalRelated = new Swiper('.used-model-internal-related-slider', {
    clickable: true,
    slidesPerView: 1,
    spaceBetween: 15,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    pagination: {
      el: '.swiper-pagination.related',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next.related',
      prevEl: '.swiper-button-prev.related',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1500: {
        slidesPerView: 4,
        spaceBetween: 15,
      }
    }
  });

  const swiperHighlights = new Swiper('.swiper-highlights', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.highlights',
      prevEl: '.swiper-button-prev.highlights',
    },
    pagination: {
      el: '.swiper-pagination.highlights',
      clickable: true
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    }
  });

  const galleryThumbs = new Swiper('.gallery-thumbs', {
    slidesPerView: 3,
    spaceBetween: 30,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      992: {
          slidesPerView: 4,
      }
    }
  });
  
  const galleryTop = new Swiper('.gallery-top', {
    slidesPerView: 1,
    spaceBetween: 10,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    clickable: true,
    thumbs: {
      swiper: galleryThumbs
    }
  });

  const swiperProductsInternalRelated = new Swiper('.products-internal-related', {
    clickable: true,
    slidesPerView: 1,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    pagination: {
      el: '.swiper-pagination.products-related',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next.products-related',
      prevEl: '.swiper-button-prev.products-related',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
      }
    }
  });

  const swiperHighlightsGalery = new Swiper('.swiper-highlights-gallery', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    slidesPerView: 'auto',
    spaceBetween: 10,
    watchOverflow: true,
    pagination: {
      el: '.swiper-pagination.highlights-gallery',
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 3
    },
    breakpoints: {
      992: {
        slidesPerView: 'auto',
        spaceBetween: 10,
      }
    }
  });

  const swiperNewModelVerson = new Swiper('.swiper-new-model-version', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.version',
      prevEl: '.swiper-button-prev.version',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  const swiperHomeHighlightsBanner = new Swiper('.swiper-home-highlights-banner', {
  observer: true,
  observeParents: true,
  observeSlideChildren: true,
  watchOverflow: true,
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-next.home-highlights-banner',
    prevEl: '.swiper-button-prev.home-highlights-banner',
  },
  pagination: {
    el: '.swiper-pagination.home-highlights-banner',
    clickable: true,
  },
  breakpoints: {
    1200: {
      slidesPerView: 2,
    }
  }
  })

}
